import { ROUTE_PATH, YEARS_COMPANY } from "common/constants/sm-constants";
import { FormMetaModel, SmMetaInputModel, SmBtnMetaModel, SmMetaSelectModel, SmDatepickerModel } from "common/models/utility-models/meta-model";

export class AddInternshipMetaModel extends FormMetaModel {
    constructor() {
        super('Add Internship', ROUTE_PATH.internship, ROUTE_PATH.AddInternship, 2);
    }

    override initProperties(): any {
        const formInfo = super.initProperties();

         const year = new SmMetaSelectModel(
            'year',
            'year',
            'select',
            false,
            'col-12 col-md-4 mb-1',
            1,
            1,
            'Select Year',
            'text',
            '',
            false,
            true,
            true,
            false,
            0,
            0,
            false,
            YEARS_COMPANY,
            'value',
            'name',
        );
        const internshipTitle = new SmMetaInputModel(
            'internshipTitle',
            'internshipTitle',
            'input',
            true,
            'col-12 col-md-4',
            1,
            2,
            'Internship Title',
            'text',
            '',
            false,
            true,
            true,
            false,
            100,
            1
          );

          const internshipStartDate = new SmDatepickerModel(
            'internshipStartDate',
            'internshipStartDate',
            'datepicker',
            true,
            'col-12 col-md-4 mb-2',
            1,
            2,
            'Internship Starts',
            'text',
            '',
            false,
            true,
            true,
            false,
            false,
            'DD/MM/YYYY',
            new Date('1970-10-19'),
            new Date('2040-01-01'),
            [],
            false
        );

        const internshipEndDate = new SmDatepickerModel(
            'internshipEndDate',
            'internshipEndDate',
            'datepicker',
            true,
            'col-12 col-md-4 mb-2',
            1,
            2,
            'internship ends',
            'text',
            '',
            false,
            true,
            true,
            false,
            false,
            'DD/MM/YYYY',
            new Date('1970-10-19'),
            new Date('2040-01-01'),
            [],
            false
        );

        const internshipCompanyId = new SmMetaSelectModel(
            'internshipCompanyId',
            'internshipCompanyId',
            'select',
            true,
            'col-12 col-md-4 mb-1',
            1,
            3,
            'Company Name',
            'text',
            '',
            false,
            true,
            true,
            false,
            0,
            0,
            false,
            [],
            'companyName',
            'id',
        );

        const internshipCompanyLocationId = new SmMetaSelectModel(
            'internshipCompanyLocationId',
            'internshipCompanyLocationId',
            'select',
            true,
            'col-12 col-md-4 mb-1',
            1,
            3,
            'Location',
            'text',
            '',
            false,
            true,
            true,
            false,
            0,
            0,
            false,
            [],
            'locName',
            'id',
        );
        //   internshipStartDate

        const Address = new SmMetaInputModel(
            'Address',
            'Address',
            'input',
            true,
            'input-fg form-group col-6 col-md-4',
            1,
            3,
            'Address',
            'text',
            '',
            false,
            true,
            true,
            false,
            200,
            4,
            
        );

        const accommodationAddress = new SmMetaInputModel(
            'accommodationAddress',
            'accommodationAddress',
            'input',
            false,
            'input-fg form-group col-6 col-md-4',
            1,
            4,
            'Accommodation Address',
            'text',
            '',
            false,
            true,
            true,
            false,
            200,
            4,
            
        );

        const accommodationContactPerson = new SmMetaInputModel(
            'accommodationContactPerson',
            'accommodationContactPerson',
            'input',
            false,
            'input-fg form-group col-6 col-md-4',
            1,
            4,
            'Accommodation Contact Person',
            'text',
            '',
            false,
            true,
            true,
            false,
            100,
            4,
            
        );

        

        const internshipProjectName = new SmMetaInputModel(
            'internshipProjectName',
            'internshipProjectName',
            'input',
            false,
            'input-fg form-group col-6 col-md-4',
            1,
            4,
            'Project Name',
            'text',
            '',
            false,
            true,
            true,
            false,
            100,
            4,
            
        );

        const internshipCompanyMentorId = new SmMetaSelectModel(
            'internshipCompanyMentorId',
            'internshipCompanyMentorId',
            'select',
            true,
            'col-12 col-md-4 mb-1',
            1,
            5,
            'Mentor',
            'text',
            '',
            false,
            true,
            true,
            false,
            0,
            0,
            false,
            [],
            'mentorName',
            'id',
        );

        const mentorEmail = new SmMetaInputModel(
            'mentorEmail',
            'mentorEmail',
            'input',
            true,
            'input-fg form-group col-6 col-md-4',
            1,
            5,
            'Mentor Email',
            'text',
            '',
            false,
            true,
            true,
            false,
            100,
            4,
            
        );

        const mentorPhone = new SmMetaInputModel(
            'mentorPhone',
            'mentorPhone',
            'input',
            false,
            'input-fg form-group col-6 col-md-4',
            1,
            5,
            'Mentor Phone',
            'text',
            '',
            false,
            true,
            true,
            false,
            10,
            0,
            
        );

        const guideName = new SmMetaInputModel(
            'guideName',
            'guideName',
            'input',
            false,
            'input-fg form-group col-6 col-md-4',
            1,
            6,
            'Guide Name',
            'text',
            '[a-zA-Z][a-zA-Z ]+',
            false,
            true,
            true,
            false,
            100,
            4,
            
        );


        const guideEmail = new SmMetaInputModel(
            'guideEmail',
            'guideEmail',
            'input',
            false,
            'input-fg form-group col-6 col-md-4',
            1,
            6,
            'Guide Email',
            'text',
            '',
            false,
            true,
            true,
            false,
            100,
            4,
            
        );

        const guideMobile = new SmMetaInputModel(
            'guideMobile',
            'guideMobile',
            'input',
            false,
            'input-fg form-group col-6 col-md-4',
            1,
            6,
            'Guide Mobile',
            'number',
            '',
            false,
            true,
            true,
            false,
            10,
            10,
            
        );

        const hrName = new SmMetaInputModel(
            'hrName',
            'hrName',
            'input',
            false,
            'input-fg form-group col-6 col-md-4',
            1,
            7,
            'HR Name',
            'text',
            '[a-zA-Z][a-zA-Z ]+',
            false,
            true,
            true,
            false,
            100,
            4,
            
        );


        const hrMobile = new SmMetaInputModel(
            'hrMobile',
            'hrMobile',
            'input',
            false,
            'input-fg form-group col-6 col-md-4',
            1,
            7,
            'HR Mobile',
            'number',
            '',
            false,
            true,
            true,
            false,
            10,
            10,
            
        );

        const hrEmail = new SmMetaInputModel(
            'hrEmail',
            'hrEmail',
            'input',
            false,
            'input-fg form-group col-6 col-md-4',
            1,
            7,
            'HR Email',
            'text',
            '',
            false,
            true,
            true,
            false,
            100,
            4,
            
        );

        const student_ids = new SmMetaSelectModel(
            'student_ids',
            'student_ids',
            'ng-select',
            true,
            'col-12 col-md-4 mb-1',
            1,
            5,
            'Add Student',
            'text',
            '',
            false,
            true,
            true,
            false,
            0,
            0,
            false,
            [],
            'name',
            'studentId',
            true,
        );
             

        const submit = new SmBtnMetaModel('Save', '', true, false, true, false);
        

        return {
            year ,
            internshipTitle,
            internshipStartDate ,
            internshipEndDate ,
            internshipCompanyId ,
            internshipCompanyLocationId ,
            Address,              // confm with Api first
            accommodationAddress,
            accommodationContactPerson ,
            internshipProjectName,
            mentorPhone, // confm with Api first
            mentorEmail, // confm with Api first
            guideEmail ,
            guideMobile ,
            guideName ,
            hrEmail ,
            hrMobile ,
            hrName ,
            internshipCompanyMentorId ,  
            student_ids,
            submit,
            formInfo,
            
           
            
        };
    }
}